export default "__VITE_ASSET__x$LBjzPz__"